import * as React from 'react';
import styles from './index.less';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
  OnUpdate_Data_Action,
} from '@/models/resourceSider';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'dva';
import { ConnectState, ResourceVersionEditorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import useUrlState from '@/hooks/useUrlState';
import FComponentsLib from '@freelog/components-lib';
import { Space, Badge } from 'antd';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import {
  ChangeAction,
  SyncAllPropertiesAction,
  UpdateDataSourceAction,
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  OnChange_Version_Action,
} from '@/models/resourceVersionEditorPage';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import FBraftEditor from '@/components/FBraftEditor';
import BraftEditor, { EditorState } from 'braft-editor';
import FViewportCards_Resource from '@/components/FAntvG6/FViewportCards_Resource';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import FSkeletonNode from '@/components/FSkeletonNode';
import fMessage from '@/components/fMessage';
import FHtmlReactParser from '@/components/FHtmlReactParser';
import { Helmet } from 'react-helmet';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fFilePreviewer from '@/components/fFilePreviewer';
import FMicroApp_CartoonEditorDrawer from '@/components/FMicroApp_CartoonEditorDrawer';
import FMicroApp_MarkdownEditorDrawer from '@/components/FMicroApp_MarkdownEditorDrawer';
import FTextBtn from '@/components/FButton/FTextBtn';
import FIcons from '@/components/FIcons';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import FDropdown2 from '@/components/FDropdown2';
import FFileIcon from '@/components/FFileIcon';
// import FPrompt2 from '@/components/FPrompt2';
import FPrompt from '@/components/FPrompt';
interface VersionInfoProps {
  dispatch: Dispatch;
  resourceVersionEditorPage: ResourceVersionEditorPageModelState;
}

function VersionInfo({ dispatch, resourceVersionEditorPage }: VersionInfoProps) {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [$urlState, set$urlState] = useUrlState<{ version: string }>({
    version: '',
  });
  const [isEditing, setIsEditing] = React.useState<boolean>(false);
  const [editor, setEditor] = React.useState<EditorState>(
    BraftEditor.createEditorState(resourceVersionEditorPage.description),
  );
  const [$customOptionsExpansion, set$customOptionsExpansion] = React.useState<boolean>(false);

  const [$cartoonPreviewerOpen, set$cartoonPreviewerOpen, get$cartoonPreviewerOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$markdownPreviewerOpen, set$markdownPreviewerOpen, get$markdownPreviewerOpen] =
    FUtil.Hook.useGetState<boolean>(false);

  // const [$isEditing_Description, set$isEditing_Description] = React.useState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });

    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'versionInfo',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceVersionEditorPage/onMount_Page',
      payload: {
        resourceID: params.id!,
        version: $urlState.version,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'resourceVersionEditorPage/onUnmount_Page',
    });
  });

  React.useEffect(() => {
    setEditor(BraftEditor.createEditorState(resourceVersionEditorPage.description));
  }, [resourceVersionEditorPage.description]);

  async function onChange(payload: Partial<ResourceVersionEditorPageModelState>) {
    await dispatch<ChangeAction>({
      type: 'resourceVersionEditorPage/change',
      payload,
    });
  }

  const isRssRelated = resourceVersionEditorPage.isRssRelated;

  return (
    <>
      <FPrompt
        watch={isEditing}
        onOk={(locationHref) => {
          navigate(locationHref);
        }}
      />
      <Helmet>
        <title>{`资源及其属性 · ${
          resourceVersionEditorPage.resourceInfo?.resourceName || ''
        }  - Freelog`}</title>
      </Helmet>
      {resourceVersionEditorPage.pageState === 'loading' && (
        <div className={styles.root}>
          <div className={styles.skeleton}>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          </div>
        </div>
      )}

      {resourceVersionEditorPage.version === '' && (
        <div
          className={styles.noData}
          style={{
            height: 'calc(100vh - 70px)',
            display: resourceVersionEditorPage.pageState === 'loaded' ? 'block' : 'none',
          }}
        >
          <div />
          {!resourceVersionEditorPage.draft && (
            <div>
              <FComponentsLib.FTipText type='first' text={'上传资源，开启授权之旅'} />

              <div style={{ height: 30 }} />
              <FHotspotTooltip
                id={'resourceVersionEditorPage.noVersionAndCreateVersion'}
                style={{ left: -44, top: 8 }}
                text={FI18n.i18nNext.tAuto('hotpots_editresource_btn_createnewversion')}
                onMount={() => {
                  fSetHotspotTooltipVisible('resourceVersionEditorPage.noVersionAndCreateVersion', {
                    value: false,
                    effectiveImmediately: false,
                    onlyNullish: false,
                  });
                }}
              >
                <FComponentsLib.FRectBtn
                  size='large'
                  className={styles.btn}
                  onClick={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionCreator({
                        resourceID: params.id!,
                      }),
                    );
                  }}
                >
                  上传资源
                </FComponentsLib.FRectBtn>
              </FHotspotTooltip>
            </div>
          )}

          {!!resourceVersionEditorPage.draft && (
            <div>
              <div
                style={{
                  fontSize: 30,
                  color: '#666',
                  lineHeight: '42px',
                }}
              >
                {FI18n.i18nNext.tAuto('versionmngt_empty_msg2')}
              </div>
              <div style={{ height: 40 }} />
              <Space size={40}>
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  onClick={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionCreator({
                        resourceID: params.id!,
                      }),
                    );
                  }}
                >
                  {FI18n.i18nNext.tAuto('versionmngt_empty_btn_continueediting')}
                </FComponentsLib.FTextBtn>
                <FComponentsLib.FTextBtn
                  type={'default'}
                  onClick={async () => {
                    const { ret, errCode, msg } = await FServiceAPI.Resource.deleteResourceDraft({
                      resourceId: params.id!,
                    });
                    if (ret !== 0 || errCode !== 0) {
                      fMessage(msg, 'error');
                      return;
                    }
                    dispatch<ChangeAction>({
                      type: 'resourceVersionEditorPage/change',
                      payload: {
                        draft: null,
                      },
                    });
                  }}
                >
                  {FI18n.i18nNext.tAuto('versionmngt_empty_btn_discard')}
                </FComponentsLib.FTextBtn>
              </Space>
            </div>
          )}
          <div />
        </div>
      )}

      {resourceVersionEditorPage.version !== '' && (
        <div
          style={{
            width: '100%',
            display: resourceVersionEditorPage.pageState === 'loaded' ? 'block' : 'none',
          }}
        >
          <div className={styles.root}>
            <div style={{ height: 40 }} />

            <div className={styles.Header}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FDropdown2
                  autoArrow={true}
                  menu={{
                    selectedKeys: [resourceVersionEditorPage.version],
                    items: resourceVersionEditorPage.versions.map((v) => {
                      return {
                        key: v,
                        label: v,
                      };
                    }),
                    onClick: (value) => {
                      if (value.key !== resourceVersionEditorPage.version) {
                        dispatch<OnChange_Version_Action>({
                          type: 'resourceVersionEditorPage/onChange_Version',
                          payload: {
                            version: value.key,
                          },
                        });
                      }
                    },
                  }}
                >
                  <FComponentsLib.FContentText
                    text={
                      // 当前版本 1.0.0
                      `${FI18n.i18nNext.tAuto('edit_resource_vmgnt_label_currentversion')} ${
                        resourceVersionEditorPage.version
                      }`
                    }
                    type={'highlight'}
                    singleRow
                    style={{ maxWidth: 750, fontSize: 16 }}
                  />
                </FDropdown2>
                <div style={{ width: 30 }} />
                <Badge
                  count={
                    !!resourceVersionEditorPage.draft //hasDraft
                      ? '草稿'
                      : 0
                  }
                  size={'small'}
                  offset={[20, 0]}
                >
                  <FComponentsLib.FTextBtn
                    style={{ display: 'flex', alignItems: 'center', gap: 5 }}
                    disabled={isRssRelated}
                    onClick={() => {
                      self.open(
                        FUtil.LinkTo.resourceVersionCreator({
                          resourceID: resourceVersionEditorPage.resourceID,
                        }),
                      );
                    }}
                  >
                    <FIcons.FUpdateVersion style={{ fontSize: 14 }} />
                    <span>
                      {
                        // 更新版本
                        FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_update')
                      }
                    </span>
                  </FComponentsLib.FTextBtn>
                </Badge>
              </div>
              <div style={{ height: 10 }} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FComponentsLib.FContentText
                  type='additional2'
                  text={
                    FI18n.i18nNext.tAuto('release_date') +
                    (resourceVersionEditorPage.resourceVersionInfo?.createData || '')
                  }
                />
                <div style={{ width: 40 }} />
              </div>
            </div>

            <div style={{ height: 40 }} />

            {/* 资源版本卡片 - 独立块，padding 由 baseInfo 提供，避免双重 padding */}
            <div className={styles.blockCard}>
              <div className={styles.baseInfo}>
                <div className={styles.baseInfoLeft}>
                  <div
                    className={[
                      styles.baseInfoLeftIcon,
                      resourceVersionEditorPage.resourceTypeConfig.autoGenerateCover &&
                      resourceVersionEditorPage.resourceVersionFileInfo?.sha1
                        ? styles.baseInfoLeftIcon_withImage
                        : styles.baseInfoLeftIcon_iconOnly,
                    ].join(' ')}
                  >
                    <FFileIcon
                      mime={resourceVersionEditorPage.resourceVersionFileInfo?.mime || ''}
                      // url={
                      //   FUtil.Format.completeUrlByDomain('api') +
                      //   `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`
                      // }
                      sha1={
                        (resourceVersionEditorPage.resourceTypeConfig.autoGenerateCover
                          ? resourceVersionEditorPage.resourceVersionFileInfo?.sha1
                          : '') || ''
                      }
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <FComponentsLib.FContentText
                      text={resourceVersionEditorPage.resourceVersionFileInfo?.fileName}
                      type={'highlight'}
                      style={{ maxWidth: 400, fontSize: 14, fontWeight: 600, color: '#222' }}
                      singleRow
                    />
                    <FComponentsLib.FContentText
                      text={`${FI18n.i18nNext.tAuto('object_id')}：${
                        resourceVersionEditorPage.resourceVersionFileInfo?.sha1
                      }`}
                      type={'additional2'}
                      style={{ maxWidth: 400, fontSize: 12, color: '#999' }}
                      singleRow
                    />
                  </div>
                </div>
                <div className={styles.baseInfoRight}>
                  {resourceVersionEditorPage.resourceVersionFileInfo?.mime &&
                    (resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith('image/') ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith(
                        'video/',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith(
                        'audio/',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime.includes(
                        'text/plain',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime.includes(
                        'text/markdown',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime ===
                        'application/vnd.freelog.comic') && (
                      <FTextBtn
                        type='primary'
                        size='default'
                        onClick={() => {
                          if (
                            resourceVersionEditorPage.resourceVersionFileInfo?.mime ===
                            'application/vnd.freelog.comic'
                          ) {
                            set$cartoonPreviewerOpen(true);
                            return;
                          }

                          if (
                            resourceVersionEditorPage.resourceVersionFileInfo?.mime.includes(
                              'text/markdown',
                            )
                          ) {
                            set$markdownPreviewerOpen(true);
                            return;
                          }

                          const url: string =
                            FUtil.Format.completeUrlByDomain('api') +
                            `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`;
                          fFilePreviewer({
                            url: url,
                            mime: resourceVersionEditorPage.resourceVersionFileInfo?.mime || '',
                          });
                        }}
                      >
                        <FIcons.FMappingRuleOnline
                          style={{
                            fontSize: 14,
                            color: 'inherit',
                          }}
                        />
                        <span>
                          {
                            // 预览
                            FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_preview')
                          }
                        </span>
                      </FTextBtn>
                    )}

                  {resourceVersionEditorPage.resourceInfo?.resourceType[0] === '阅读' &&
                  resourceVersionEditorPage.resourceInfo?.resourceType[1] === '漫画' ? (
                    <FDropdown2
                      autoArrow={false}
                      // getPopupContainer={() => ref_Root.current as HTMLElement}
                      menu={{
                        // selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                        items: [
                          {
                            label: 'ZIP格式文件',
                            key: 'zip',
                          },
                          {
                            label: 'CBZ格式文件',
                            key: 'cbz',
                          },
                        ],
                        onClick: (value) => {
                          self.location.href =
                            FUtil.Format.completeUrlByDomain('api') +
                            `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download?fileSuffix=.${value.key}`;
                        },
                      }}
                    >
                      <FTextBtn type='primary' size='default'>
                        <FIcons.FDownload
                          style={{
                            fontSize: 14,
                            color: 'inherit',
                          }}
                        />
                        <span>
                          {
                            // 下载
                            FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_download')
                          }
                        </span>
                      </FTextBtn>
                    </FDropdown2>
                  ) : (
                    <FTextBtn
                      type='primary'
                      size='default'
                      onClick={() => {
                        self.location.href =
                          FUtil.Format.completeUrlByDomain('api') +
                          `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`;
                      }}
                    >
                      <FIcons.FDownload
                        style={{
                          fontSize: 14,
                          color: 'inherit',
                        }}
                      />
                      <span>
                        {
                          // 下载
                          FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_download')
                        }
                      </span>
                    </FTextBtn>
                  )}
                </div>
              </div>
            </div>

            {[
              ...resourceVersionEditorPage.systemProperties,
              ...resourceVersionEditorPage.customProperties,
            ].length > 0 && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block}>
                  <FComponentsLib.FContentText
                    text={
                      // 基础属性
                      FI18n.i18nNext.t('resourceinfo_title')
                    }
                    type={'highlight'}
                  />
                  <div style={{ height: 20 }} />
                  <FAttrsAndConfigs
                    dateSource={[
                      ...resourceVersionEditorPage.systemProperties.map<IAttrsAndConfigsItem>(
                        (sp) => {
                          return {
                            key: sp.key,
                            value: sp.value,
                            name: sp.name,
                            description: sp.description,
                            configs: {
                              item_Deletable: false,
                              key_Editable: false,
                              name_Editable: false,
                              description_Editable: false,
                              value_Editable: isRssRelated
                                ? false
                                : (sp.type === 'additional' && sp.valueConfig) || false,
                            },
                          };
                        },
                      ),
                      ...resourceVersionEditorPage.customProperties.map<IAttrsAndConfigsItem>(
                        (cp) => {
                          return {
                            key: cp.key,
                            value: cp.value,
                            name: cp.name,
                            description: cp.description,
                            configs: {
                              item_Deletable: false,
                              key_Editable: false,
                              name_Editable: false,
                              description_Editable: !isRssRelated,
                              value_Editable: isRssRelated
                                ? false
                                : {
                                    text: {
                                      nullable: true,
                                      minLength: 0,
                                      maxLength: 100,
                                    },
                                  },
                            },
                          };
                        },
                      ),
                    ]}
                    onChangeItem={
                      isRssRelated
                        ? undefined
                        : async (oldData, newData, index, changedFields) => {
                      if (index < resourceVersionEditorPage.systemProperties.length) {
                        const newDateSource = [...resourceVersionEditorPage.systemProperties];
                        newDateSource[index] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                          type: resourceVersionEditorPage.systemProperties[index].type,
                          valueConfig:
                            resourceVersionEditorPage.systemProperties[index].valueConfig,
                        };

                        await onChange({
                          systemProperties: newDateSource,
                        });
                      } else {
                        const newDateSource = [...resourceVersionEditorPage.customProperties];
                        newDateSource[index - resourceVersionEditorPage.systemProperties.length] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                        };

                        await onChange({
                          customProperties: newDateSource,
                        });
                      }
                      await dispatch<SyncAllPropertiesAction>({
                        type: 'resourceVersionEditorPage/syncAllProperties',
                        payload: {
                          successMessage: changedFields.includes('value')
                            ? FI18n.i18nNext.t('saved_successfully')
                            : undefined,
                        },
                      });
                    }}
                    disabledKeys={[]}
                    disabledNames={[]}
                  />
                </div>
                </>
              )}

            {resourceVersionEditorPage.customConfigurations.length > 0 && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('resourceoptions_title')}
                    type={'highlight'}
                  />
                  <div style={{ height: 20 }} />
                  <FResourceOptions
                    theme={'dark'}
                    actionsDisabled={isRssRelated}
                    dataSource={resourceVersionEditorPage.customConfigurations.filter((f1, f2) => {
                      return $customOptionsExpansion || f2 < 3;
                    })}
                    onEdit={async (data) => {
                      const index: number =
                        resourceVersionEditorPage.customConfigurations.findIndex((p) => {
                          return p === data;
                        });

                      const dataSource: {
                        key: string;
                        name: string;
                        type: 'input' | 'select';
                        input: string;
                        select: string[];
                        description: string;
                      } | null = await fResourceOptionEditor({
                        disabledKeys: [
                          ...resourceVersionEditorPage.systemProperties.map<string>((rp) => rp.key),
                          ...resourceVersionEditorPage.customProperties.map<string>((bp) => bp.key),
                          ...resourceVersionEditorPage.customConfigurations.map<string>(
                            (pp) => pp.key,
                          ),
                        ],
                        disabledNames: [
                          ...resourceVersionEditorPage.systemProperties.map<string>(
                            (rp) => rp.name,
                          ),
                          ...resourceVersionEditorPage.customProperties.map<string>(
                            (bp) => bp.name,
                          ),
                          ...resourceVersionEditorPage.customConfigurations.map<string>(
                            (pp) => pp.name,
                          ),
                        ],
                        defaultData: data,
                        noneEditableFields: ['key', 'name', 'type'],
                      });

                      if (!dataSource) {
                        return;
                      }
                      await onChange({
                        customConfigurations: resourceVersionEditorPage.customConfigurations.map<
                          ResourceVersionEditorPageModelState['customConfigurations'][number]
                        >((bp, i) => {
                          if (index !== i) {
                            return bp;
                          }
                          return dataSource;
                        }),
                      });
                      await dispatch<SyncAllPropertiesAction>({
                        type: 'resourceVersionEditorPage/syncAllProperties',
                      });
                    }}
                  />
                  {resourceVersionEditorPage.customConfigurations.length > 3 && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 5,
                      }}
                    >
                      {$customOptionsExpansion ? (
                        <FComponentsLib.FTextBtn
                          onClick={() => {
                            set$customOptionsExpansion(false);
                          }}
                          style={{ fontSize: 12 }}
                          type={'primary'}
                        >
                          {FI18n.i18nNext.tAuto('resourceoptions_btn_showless', {
                            OptionsQty: resourceVersionEditorPage.customConfigurations.length,
                          })}
                        </FComponentsLib.FTextBtn>
                      ) : (
                        <>
                          <FComponentsLib.FContentText
                            text={'可配置项目较多，已折叠显示'}
                            type={'additional2'}
                          />
                          <FComponentsLib.FTextBtn
                            onClick={() => {
                              set$customOptionsExpansion(true);
                            }}
                            style={{ fontSize: 12 }}
                            type={'primary'}
                          >
                            {FI18n.i18nNext.tAuto('resourceoptions_btn_showall', {
                              OptionsQty: resourceVersionEditorPage.customConfigurations.length,
                            })}
                          </FComponentsLib.FTextBtn>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}

            {(resourceVersionEditorPage.directDependencies.length > 0 ||
              resourceVersionEditorPage.baseUpcastResources.length > 0) &&
              resourceVersionEditorPage.reload > 0 && (
                <>
                  <div style={{ height: 5 }} />
                  <div className={styles.block}>
                    {resourceVersionEditorPage.reload > 0 && (
                      <FMicroAPP_Authorization
                        licenseeId={resourceVersionEditorPage.resourceID}
                        licenseeVersion={resourceVersionEditorPage.version}
                        mainAppType={'resourceInfo'}
                        depList={resourceVersionEditorPage.directDependencies}
                        upcastList={resourceVersionEditorPage.baseUpcastResources}
                        // reload={resourceVersionEditorPage.reload}
                        update={(value) => {
                          dispatch<OnUpdate_Data_Action>({
                            type: 'resourceSider/onUpdate_Data',
                            // payload: resourceAuthPage.resourceID,
                          });
                        }}
                      />
                    )}
                  </div>
                </>
              )}

            <div style={{ height: 5 }} />

            <div className={styles.block}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('version_description')}
                  type={'highlight'}
                />

                <Space size={10}>
                  {isEditing ? (
                    <>
                      {/*<FComponentsLib.FTextBtn*/}
                      {/*  type='default'*/}
                      {/*  onClick={() => {*/}
                      {/*    onChange({ descriptionFullScreen: true });*/}
                      {/*  }}*/}
                      {/*>全屏编辑</FComponentsLib.FTextBtn>*/}
                      {/*<FDivider />*/}
                      <FComponentsLib.FTextBtn type='default' onClick={() => setIsEditing(false)}>
                        {FI18n.i18nNext.tAuto('cancel')}
                      </FComponentsLib.FTextBtn>
                      <FComponentsLib.FTextBtn
                        type='primary'
                        onClick={() => {
                          const html: string = editor.toHTML();
                          const description: string = html === '<p></p>' ? '' : html;
                          dispatch<ChangeAction>({
                            type: 'resourceVersionEditorPage/change',
                            payload: {
                              description: description,
                            },
                          });
                          dispatch<UpdateDataSourceAction>({
                            type: 'resourceVersionEditorPage/updateDataSource',
                            payload: {
                              description: description,
                            },
                          });
                          setIsEditing(false);
                          if (!description) {
                            onChange({
                              descriptionFullScreen: false,
                            });
                          }
                        }}
                      >
                        {FI18n.i18nNext.tAuto('save')}
                      </FComponentsLib.FTextBtn>
                    </>
                  ) : resourceVersionEditorPage.description !== '' ? (
                    <>
                      {/*<FComponentsLib.FTextBtn*/}
                      {/*  type='default'*/}
                      {/*  onClick={() => {*/}
                      {/*    onChange({ descriptionFullScreen: true });*/}
                      {/*    // const s = self.open();*/}
                      {/*    // s.document.write(buildPreviewHtml(resourceVersionEditorPage.description))*/}
                      {/*  }}*/}
                      {/*>全屏查看</FComponentsLib.FTextBtn>*/}
                      {/*<FDivider />*/}
                      <FComponentsLib.FTextBtn
                        type='primary'
                        disabled={isRssRelated}
                        onClick={() => {
                          setIsEditing(true);
                        }}
                      >
                        编辑
                      </FComponentsLib.FTextBtn>
                    </>
                  ) : undefined}
                </Space>
              </div>

              {!resourceVersionEditorPage.description && !isEditing && (
                <>
                  <div style={{ height: 10 }} />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <FComponentsLib.FContentText
                      // text={'动动手，让你的资源看起来更丰富～'}
                      text={FI18n.i18nNext.t('version_description_empty_msg')}
                      type={'additional2'}
                    />
                    <div style={{ height: 20 }} />

                    <FComponentsLib.FRectBtn
                      type={'primary'}
                      disabled={isRssRelated}
                      onClick={() => {
                        setIsEditing(true);
                      }}
                    >
                      {/*添加版本描述*/}
                      {FI18n.i18nNext.tAuto('version_description_empty_btn')}
                    </FComponentsLib.FRectBtn>
                  </div>
                </>
              )}

              {isEditing ? (
                <>
                  <div style={{ height: 20 }} />

                  <FBraftEditor
                    value={editor}
                    // defaultValue={editorText}
                    onChange={(value: EditorState) => {
                      setEditor(value);
                    }}
                    style={{ minHeight: 500 }}
                  />
                </>
              ) : (
                resourceVersionEditorPage.description && (
                  <>
                    <div style={{ height: 20 }} />
                    <div className={styles.description}>
                      <FHtmlReactParser str={resourceVersionEditorPage.description} />
                    </div>
                  </>
                )
              )}
            </div>

            {resourceVersionEditorPage.graphShow && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block}>
                  <FComponentsLib.FContentText text={'相关视图'} type={'highlight'} />
                  <div style={{ height: 20 }} />

                  <FViewportCards_Resource
                    resourceID={resourceVersionEditorPage.resourceID}
                    version={resourceVersionEditorPage.version}
                    graphShow={['authorization', 'dependency']}
                    onMount={({ hasData }) => {
                      // console.log(hasData, 'hasDataiosdjflkjsdflkjlk');
                      dispatch<ChangeAction>({
                        type: 'resourceVersionEditorPage/change',
                        payload: {
                          graphShow: hasData,
                        },
                      });
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div style={{ height: 100 }} />
        </div>
      )}

      <FMicroApp_CartoonEditorDrawer
        open={$cartoonPreviewerOpen}
        resourceID={resourceVersionEditorPage.resourceID}
        version={resourceVersionEditorPage.version}
        appMode={'preview'}
        onChange_Saved={(saved) => {}}
        onClose={() => {
          // dispatch<OnClose_step2_editCartoon_Action>({
          //   type: 'resourceCreatorPage/onClose_step2_editCartoon',
          // });
          set$cartoonPreviewerOpen(false);
        }}
      />
      <FMicroApp_MarkdownEditorDrawer
        open={$markdownPreviewerOpen}
        resourceID={resourceVersionEditorPage.resourceID}
        version={resourceVersionEditorPage.version}
        appMode={'preview'}
        onChange_Saved={(saved) => {}}
        onClose={() => {
          // dispatch<OnClose_step2_editCartoon_Action>({
          //   type: 'resourceCreatorPage/onClose_step2_editCartoon',
          // });
          set$markdownPreviewerOpen(false);
        }}
      />
    </>
  );
}

export default connect(({ resourceVersionEditorPage }: ConnectState) => ({
  resourceVersionEditorPage: resourceVersionEditorPage,
}))(VersionInfo);
